import { render, staticRenderFns } from "./Choferes.vue?vue&type=template&id=2f7903ea"
import script from "./Choferes.vue?vue&type=script&lang=js"
export * from "./Choferes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports